import { IOptionItem } from '@wyz/types';
import { COUNTRY_STATUS } from '~/connect/schemas';
import { ICountry, ICountryRecordByLetter } from '~/connect/types';
import { LocaleUtils } from '@wyz/utils';
import { useLocale } from '~/common/context';
// eslint-disable-next-line @wyz/module/no-relative-import
import BaseAlphabeticalList from './base-alphabetical-list';

type Props = {
  tags: Array<IOptionItem>;
  onConfigure: (item: ICountry) => void;
  countries: ICountryRecordByLetter;
};
export default function CountryAlphabeticalList({
  countries,
  tags,
  onConfigure,
}: Props) {
  const locale = useLocale();
  return (
    <BaseAlphabeticalList.Container>
      <BaseAlphabeticalList.Letters
        getLetterKey={(letter) => letter}
        itemsByLetter={countries || {}}
      />
      <BaseAlphabeticalList.List
        itemsByLetter={countries || {}}
        getLetterKey={(letter) => letter}
        getItemIdentifier={(item) => item.externalId}
        getItemLabel={(item) =>
          LocaleUtils.getHumanReadableLabel({
            userLocale: locale.locale,
            locale: item.isoCode,
            fallback: item.name,
            options: { type: 'region' },
          }) ?? item.name
        }
        canConfigure={true}
        onConfigure={(item) => onConfigure(item)}
        isAdded={(item) => item.status === COUNTRY_STATUS.ACTIVE}
        preFilterer={(item) => {
          if (!tags.length) return true;

          const values = tags.map((tag) => tag.label);
          for (let index = 0; index < values.length; index++) {
            const element = values[index];
            if (
              item.name
                .trim()
                .toLowerCase()
                .includes(element.trim().toLowerCase())
            ) {
              return true;
            }
          }
          return false;
        }}
      />
    </BaseAlphabeticalList.Container>
  );
}
